<div class="progressBarBackground" [style.height.px]="backgroundHeight"  #progressBar>
  <p *ngIf="displayPercentage">{{realProgressRounded}}% {{label}}</p>
  <div class="progressBar" [style.background-color]="barColor" [style.height.px]="progressHeight" [style.width.%]="(realProgressRounded <= 100) ? (realProgressRounded<=5 && realProgressRounded >= 1)? 5:realProgressRounded : 100">
            <!-- <div class="progressBarLabel" >
                <p >{{realProgressRounded}}% {{label}}</p>
            </div> -->
  </div>
</div>